
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { supabase } from "@/integrations/supabase/client"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
}

// Helper function to get supplier name instead of ID
export async function getSupplierNameById(supplierId: string): Promise<string> {
  try {
    const { data, error } = await supabase
      .from("profiles")
      .select("name, business_name")
      .eq("id", supplierId)
      .single();
    
    if (error) throw error;
    return data?.business_name || data?.name || "Unknown Supplier";
  } catch (error) {
    console.error("Error fetching supplier name:", error);
    return "Unknown Supplier";
  }
}
